import React from 'react';
import { usePriceSummaryController, PriceUpTo } from './PriceSummary.controller';
import { BoxProps, Flex, TextV2 } from '@withjoy/joykit';
import { PRICE_CONFIG } from '@apps/card/config';
import { ThemeJson } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';

export interface PriceSummaryProps extends Omit<BoxProps, 'as' | '__css'> {
  templateCategory: StationeryTemplateCategoryEnum;
  cardConfig: ThemeJson;
  title?: string;
  priceUpTo: PriceUpTo;
  children: (summary: ReturnType<typeof usePriceSummaryController>) => React.ReactElement;
}

export const deriveFullCustomizationsFromConfig = (config: ThemeJson) => {
  return {
    quantity: config.customizations.quantity,
    size: config.customizations.size,
    paperType: config.customizations.paperType,
    shape: config.customizations.shape,
    backLayout: config.card.back.layout,
    returnAddress: config.card.envelope.layout,
    delivery: config.customizations.delivery
  };
};

const PriceSummary: React.FC<PriceSummaryProps> = ({ templateCategory, cardConfig, title, children, priceUpTo, ...restProps }) => {
  const summary = usePriceSummaryController(templateCategory, priceUpTo, PRICE_CONFIG, deriveFullCustomizationsFromConfig(cardConfig));

  if (!summary) {
    return null;
  }

  return (
    <Flex flexDirection="column" rowGap={6} {...restProps}>
      {title && <TextV2 typographyVariant="hed3">{title}</TextV2>}
      {children(summary)}
      <Flex justifyContent="space-between" alignItems="center" paddingTop={3} borderTop="1px solid #EBEBEB">
        <TextV2 typographyVariant="hed3" fontSize="15px">
          Total
        </TextV2>
        <TextV2 typographyVariant="hed3">{summary.total}</TextV2>
      </Flex>
    </Flex>
  );
};

export default PriceSummary;
